module.exports = __webpack_public_path__ + "img/logo-adobe.1f78fefd.png";